import React from 'react'
import { useTranslation } from 'react-i18next'
import { UilLayersAlt } from '@iconscout/react-unicons'

const MaterialInfo = ({
  selectedDwhMaterialForInfo,
  selectedDWHMaterialIds,
  dwhMaterialsData = [],
}) => {
  const { t } = useTranslation()

  let displayMaterial = selectedDwhMaterialForInfo
  let multipleSelectedForMappingCount = 0

  if (
    !displayMaterial &&
    selectedDWHMaterialIds &&
    selectedDWHMaterialIds.size > 0
  ) {
    const firstSelectedId = Array.from(selectedDWHMaterialIds)[0]
    displayMaterial = dwhMaterialsData.find(
      (material) => material.id === firstSelectedId,
    )
    if (selectedDWHMaterialIds.size > 1) {
      multipleSelectedForMappingCount = selectedDWHMaterialIds.size - 1
    }
  }

  if (!displayMaterial) {
    return (
      <>
        <h4>{t('material_info_title_placeholder')}</h4>
        <p>{t('dwh_material_info_placeholder')}</p>
      </>
    )
  }

  return (
    <>
      <div
        style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}
      >
        <div
          style={{
            background: 'rgb(173 181 189 / 33%)',
            borderRadius: '50%',
            height: '58px',
            width: '58px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <UilLayersAlt style={{ height: '37px', width: '37px' }} />
        </div>
        <div style={{ marginLeft: '15px' }}>
          <h3 style={{ marginBottom: '4px' }}>{displayMaterial.name}</h3>
          {multipleSelectedForMappingCount > 0 && (
            <p style={{ fontSize: '0.8em', color: '#777', margin: 0 }}>
              (+{multipleSelectedForMappingCount} {t('more_selected_suffix')})
            </p>
          )}
          <p
            style={{
              color: '#555',
              fontSize: '0.9em',
              marginTop: multipleSelectedForMappingCount > 0 ? '4px' : '0px',
            }}
          >
            {displayMaterial.description || t('no_description_available')}
          </p>
        </div>
      </div>
    </>
  )
}

export default MaterialInfo
